import React, { useCallback, useEffect, useRef, useState } from "react";

import BrandViewModel from "./BrandViewModel";

import { Button } from "primereact/button";
import { Column, ColumnEditorOptions, ColumnEvent } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableFilterMetaData } from "primereact/datatable";
import { InputText } from "primereact/inputtext";

import { FilterMatchMode } from "primereact/api";

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { Controller, useForm } from "react-hook-form";
import { useToast } from "../../../../Shared/hook/useToast";
import { Brand } from "../../Domain/Model/Brand";
import './Brand.css';
 

interface ColumnMeta {
  field: string;
  header: string;
  editable: boolean;
}

export const BrandView = ()=> {
  const [filters, setFilters] = useState<DataTableFilterMeta>({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }});
  // const toast = useRef<Toast>(null);
  const { showSuccess, showError, showWarn, showInfo } = useToast();
  const defaultValues = { 
    name: '',
    image: '',
};
  const [visible, setVisible] = useState<boolean>(false);
  const {
    getBrands,
    getBrandsList,
    createBrand,
    removeBrand,
    updateBrand,
    onChangeBrand,
    brands,
    brandsList
  } = BrandViewModel();

  type LazyParamsType = {
    first: number;
    rows: number;
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [lazyParams, setLazyParams] = useState<LazyParamsType>({
      first: 0,
      rows: 10,
  });
  
  const columns: ColumnMeta[] = [
      // {field: 'id', header: 'Id', editable: false},
      {field: 'name', header: 'Name', editable: true},
      {field: 'image', header: 'Image', editable: false},
      {field: 'options', header: 'Opciones', editable: false},
  ];
  
      useEffect(() => {
        getBrandsList();
        // const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
        // loadbrands(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [lazyParams, filters]);

    const loadbrands = async (first: number, rows: number, search: string = '') => {
    setLoading(true);
    const page = Math.floor(first / rows);

    try {
        const result = await getBrands(page+1, rows, search); // ya devuelve { items, totalItems }
        
        setTotalRecords(result.totalCount);
        } catch (error) {
        console.error("Error al cargar productos", error);
        } finally {
        setLoading(false);
        }
    };

      const accept = async (id: string) => {
        
        let deleted = await removeBrand(id);
        console.log(deleted);
        if(deleted){
          showInfo('Confirmada', 'has aceptado');
          const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
          await loadbrands(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
        }      
    }

    const reject = () => {
        showWarn('Rechazada', 'has rechazado');
    }

      const onSubmit = (
        data: { 
            name: string,
            image: string,
        }
        ) => {
          data.name && showSuccess("Se registro", data.name);
          let datos =  data;
          if(datos){
            const brandData: Brand = {
              name: data.name,
              image: data.image,
              id: "",
              
            };
            createBrand(brandData);
          }
          const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
          loadbrands(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);
          console.log(datos);
          reset();
      };

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };


      const isUpdatingRef = useRef(false);
      // const onCellEditComplete = useCallback( async(e: ColumnEvent) => {
      //     // Guard contra doble ejecución simultánea
      //     if (isUpdatingRef.current) return;
      //     isUpdatingRef.current = true;
      //     let { rowData, newValue, field, originalEvent: event } = e;

      //     // 1. Validar vacío
      //     if (!newValue || newValue.trim().length === 0) {
      //       event.preventDefault();
      //       return;
      //     }

      //     // 2. Evitar mutar directamente rowData
      //     if (rowData[field] === newValue) {
      //       // No hubo cambios → no disparamos API
      //       return;
      //     }

      //     // 3. Crear copia actualizada
      //     const updatedRow = { ...rowData, [field]: newValue };

      //     await updateBrandData(updatedRow, event);
      // }, []);

      const onCellEditComplete = useCallback(async (e: ColumnEvent) => {
          if (isUpdatingRef.current) return;
          isUpdatingRef.current = true;

          let { rowData, newValue, field, originalEvent: event } = e;

          if (newValue === null || newValue === undefined || newValue === "") {
            event.preventDefault();
            isUpdatingRef.current = false;
            return;
          }

          if (rowData[field] === newValue) {
            event.preventDefault();
            isUpdatingRef.current = false;
            return;
          }

          const updatedRow = { ...rowData, [field]: newValue };

          await updateBrandData(updatedRow, field, event);

          isUpdatingRef.current = false;
        }, []);


      const updateBrandData = async (rowData: any, field: string, e: any) => {
        try {
          const data = await updateBrand(rowData);

          if (data) {
            showSuccess("Se actualizó", "Se ha actualizado con éxito!");
            getBrandsList();
          }
        } catch (error) {
          console.error("Error al actualizar:", error);
          showError("Error", "No se pudo actualizar");
          e.preventDefault();
        }
      };

      //  const updateBrandData = async (rowData: any, e: any)=>{
      //     // const data = await updateBrand(rowData);
      //     // if(data){
      //     //    show("success", "Se actualizo", rowData.name);
      //     // }
      //    try {
      //     const data = await updateBrand(rowData);

      //     if (data) {
      //       showSuccess("Se actualizo", "Se ha actualizado con éxito!");

      //       // Opciones:
      //       // A) Recargar todo desde la API
      //       // const search = (filters['global'] as DataTableFilterMetaData)?.value || '';
      //       // await loadbrands(lazyParams.first ?? 0, lazyParams.rows ?? 10, search);

      //       getBrandsList();

      //       // B) O solo actualizar en el estado local:
      //       // setCategories(prev =>
      //       //   prev.map(cat => cat.id === updatedRow.id ? updatedRow : cat)
      //       // );
      //     }
      //   } catch (error) {
      //     console.error("Error al actualizar:", error);
      //     showError("Error", "No se pudo actualizar");
      //     e.preventDefault();
      //   }

      // }

      const cellEditor = (options: ColumnEditorOptions) => {
          // if (options.field === 'icon') return viewIcons();
          // else return textEditor(options);
          return textEditor(options);
      };

      const textEditor = (options: ColumnEditorOptions) => {
          return (
              <InputText 
                  type="text" 
                  value={options.value || ''} // Asegúrate de que options.value no sea nulo o indefinido
                  onChange={(e) => options.editorCallback!(e.target.value)} 
              />
          );
      };


      const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = event.target.value;
          let _filters = { ...filters };
          // @ts-ignore
          _filters['global'].value = value.toString() || '';

          setFilters(_filters);
          // setGlobalFilterValue(value);
      };


      const header = ()=>{
        // @ts-ignore
       const value = filters['global'] ? filters['global'].value : '';

       return (
           <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
               <h4 className="m-0">
                   <button type="button" className="btn btn-dark" onClick={() => setVisible(true)}>
                    <FontAwesomeIcon icon={icon({name: 'plus'})} /> 
                   Nueva marca</button>

               </h4>
               <span className="p-input-icon-left">
                   <i className="pi pi-search" />
                   <InputText type="search" value={value || ''} onChange={(e) => 
                       onGlobalFilterChange(e)} placeholder="Buscar..." />
               </span>
           </div>
      )};

      const btnOptions = (id: string, name: string) => {

        return(
            <>
                <div className="d-flex">
                    <button onClick={()=>confirmDelete(id)} className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'trash'})} /></button>
                </div>
            </>
        );
    }

    const confirmDelete = (id: string) => {

      confirmDialog({
          message: '¿Quieres eliminar este registro?',
          header: 'Eliminar confirmación',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Si',
          rejectLabel: 'No',
          accept: () => accept(id),
          reject
      });
  };

      // const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
      // const paginatorRight = <Button type="button" icon="pi pi-download" text />;
    
    return (
        <>
          <div className="container-fluid">
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Lista Marcas</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>
                            <li className="breadcrumb-item">Lista Marcas</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            <div className="page_action">
                                {/* <button type="button" className="btn btn-dark"><FontAwesomeIcon icon={icon({name: 'plus'})} /> Nuevo producto</button> */}
                            </div>
                            <div className="p-2 d-flex">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    Aquí puedes ver las últimas marcas añadidas
                </div>
                {/* <InputSwitch  key={'index01254'} checked={checkedw} onChange={(e: InputSwitchChangeEvent) =>  setCheckedw(!checkedw)} /> */}
                
            </div>
            <div className='row'>
              <div className='col-lg-12'>
                {/* <Toast ref={toast} /> */}
                {/* <ConfirmDialog /> */}
                <DataTable 
                value={brandsList!} 
                 rows={10} 
                  // lazy 
                  paginator 
                  // rows={lazyParams.rows} 
                  // first={lazyParams.first}
                  // totalRecords={totalRecords}
                  // loading={loading} 
                  editMode="cell" 
                  rowsPerPageOptions={[5, 10, 25, 50]} 
                  tableStyle={{minWidth: '50rem'}}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}" 
                  // paginatorLeft={paginatorLeft} 
                  // paginatorRight={paginatorRight}  
                  globalFilterFields={['id', 'name']} 
                  emptyMessage="No customers found." stateStorage="session"
                  header={header}
                  filters={filters}
                  onFilter={(e) => {
                    setFilters(e.filters);
                    setLazyParams({ ...lazyParams, first: 1, rows: 1 });
                  }}>

                    {columns.map(({ field, header, editable  }) => {
                            return <Column key={field} field={field} header={header}    
                            body={ 
                              field === 'options' ? (e)=> btnOptions(e.id, e.name) : null 
                            } 
                            editor={editable ? (options) => cellEditor(options) : undefined} onCellEditComplete={onCellEditComplete} />
                    })}
                </DataTable>
                <Dialog header="Agregar Marca" visible={visible} maximizable style={{ width: '400px' }} onHide={() => setVisible(false)}>
                  <form onSubmit={handleSubmit(onSubmit)} className="text-start">
                    {/* <Toast ref={toast} /> */}
                    <div className="d-flex flex-column gap-2 ">
                        <Controller
                            name="name"
                            control={control}
                            rules={{ required: 'Nombre es requerido.' }}
                            render={({ field, fieldState }) => (
                            <>
                                <label htmlFor={field.name}>
                                    Nombre
                                </label>
                                <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} />
                                {getFormErrorMessage(field.name)}
                            </>       
                        )}
                        />
                        <Button label="Guardar" type="submit" icon="pi pi-check" className={"btn btn-dark"} />
                    </div>
                    
                  </form>
                </Dialog>
              </div>
            </div>
          </div>
        </>
    );
}